import { render, staticRenderFns } from "./CardCover.vue?vue&type=template&id=888cbd62&scoped=true"
import script from "./CardCover.vue?vue&type=script&lang=js"
export * from "./CardCover.vue?vue&type=script&lang=js"
import style0 from "./CardCover.vue?vue&type=style&index=0&id=888cbd62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888cbd62",
  null
  
)

export default component.exports